module.exports = __webpack_public_path__ + "static/media/modelx@2x.e7c0dd8a.png";